export const APPLY = "apply";
export const BOTH = "both";
export const BOTTOM = "bottom";
export const CANCEL = "cancel";
export const CENTER = "center";
export const CHECKBOX = "checkbox";
export const CONTAINS = "contains";
export const CONTRAST = "contrast";
export const DANGER = "danger";
export const DATE = "date";
export const DATE_IS = "dateIs";
export const DEFAULT = "default";
export const DROPDOWN = "dropdown";
export const ENDS_WITH = "endsWith";
export const EQUALS = "equals";
export const ERROR = "error";
export const FLEX = "flex";
export const FOCUS = "focus";
export const FULL = "full";
export const HELP = "help";
export const HOVER = "hover";
export const INFO = "info";
export const INT = "int";
export const LARGE = "large";
export const LEFT = "left";
export const LOCALE = navigator.language;
export const MOUSE = "mouse";
export const MULTIPLE = "multiple";
export const NARROW = "narrow";
export const NORMAL = "normal";
export const NOT_EQUALS = "notEquals";
export const NUMERIC = "numeric";
export const PAGINATOR_TEMPLATE = "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"; /* prettier-ignore */
export const RADIO_BUTTON = "radiobutton";
export const RANGE = "range";
export const RIGHT = "right";
export const ROW = "row";
export const SAVE = "save";
export const SECONDARY = "secondary";
export const SELF = "self";
export const SHORT = "short";
export const SINGLE = "single";
export const SMALL = "small";
export const STARTS_WITH = "startsWith";
export const SUCCESS = "success";
export const TALL = "tall";
export const TEXT = "text";
export const TOP = "top";
export const WARN = "warn";
export const WARNING = "warning";
export const WIDE = "wide";
